interface IpResponse {
  ip: string
}

interface GeoJsResponse {
  country: string
  country_3: string
  name: string
  ip: string
}

const geolocateByIp = async (ip: string): Promise<string | null> => {
  try {
    const response = await fetch(
      `https://get.geojs.io/v1/ip/country/${ip}.json`
    )
    if (!response.ok) {
      return null
    }
    const { country }: GeoJsResponse = await response.json()
    return country.toLowerCase()
  } catch (e) {
    return null
  }
}

const getIpAddress = async (): Promise<string | null> => {
  try {
    const response = await fetch(`https://api.ipify.org/?format=json`)
    if (!response.ok) {
      return null
    }
    const { ip }: IpResponse = await response.json()
    return ip
  } catch (e) {
    return null
  }
}

export const defaultLocation = "US"

export const detectCurrentLocation = async () => {
  try {
    const ip = await getIpAddress()
    if (!ip) throw new Error()
    return geolocateByIp(ip)
  } catch (error) {
    return null
  }
}
